/**
 * Edit Network Corridor Form Schema
 *
 * Reuses the Add Network Corridor schema and API transform while
 * loading its own YAML config for edit-specific metadata.
 */

import { FormConfigLoader } from '@/lib/formConfigLoader'
import formYaml from './form.yml?raw'
import {
  AddNetworkCorridorFormSchema,
  type AddNetworkCorridorFormData,
  transformToApiRequest as addTransformToApiRequest,
} from '../addNetworkCorridor/schema'

// ============================================================================
// Export Form Metadata from YAML
// ============================================================================

const formConfig = FormConfigLoader.loadFormConfig(formYaml)

export const FORM_CONFIG = formConfig
export const FORM_NAME = formConfig.formName
export const FORM_TITLE = formConfig.formTitle
export const FORM_DESCRIPTION = formConfig.formDescription

// ============================================================================
// Schema & Types
// ============================================================================

export const EditNetworkCorridorFormSchema = AddNetworkCorridorFormSchema
export type EditNetworkCorridorFormData = AddNetworkCorridorFormData

// ============================================================================
// API Request Transformation
// ============================================================================

export function transformToApiRequest(formData: EditNetworkCorridorFormData) {
  return addTransformToApiRequest(formData)
}

